export const FEATURE_FLAGS = {
	google_maps: true,
	mission_generation: false,
	voice_enabled: false,
	dialer_enabled: false,
	transcript_enabled: false,
	/**
	 * PreQual follow-up action side-effects (email / WhatsApp sends).
	 *
	 * Off by default: the UI still offers scouts "email" / "whatsapp" as
	 * selectable follow-up options and captures the selection in the submit
	 * payload under `qualification_answers.folgeaktion` (valuable intent
	 * data). But the actual outbound send is gated until we ship:
	 *   - real email/whatsapp templates (prequal_qualified, prequal_info, …)
	 *   - sender-identity decision (which mailbox / number)
	 *   - DSGVO consent & opt-out mechanism for the lead
	 *   - SL proxy routes to comms email/whatsapp adapters
	 *
	 * Anchor: scout_activity_log showed 10 `folgeaktion_email_failed` HTTP
	 * 404 events over 6 days (Rüdiger thought he was sending follow-up
	 * emails; nothing reached the lead). False-confidence UX is worse
	 * than missing feature. Commander 2026-04-25: "we need to capture
	 * them but not send" — flag off until templates + legal + infra ready.
	 * See FR-FOLGEAKTION-SEND-NOT-SHIPPABLE for the activation checklist.
	 */
	folgeaktion_send_enabled: false,
	/**
	 * Governed field-day LIVE flow (WU-0..5): the PLAN⇄LIVE toggle + the
	 * per-stop LiveStopFlow ladder (StopExpose → EnRoute → AtVisit → reporting).
	 *
	 * Off by default: the flow was built (commit b4a9fcb8) then UN-MOUNTED
	 * (c7d10665) — "Steffen does not use it" — leaving the pre-WU5 planning
	 * surface (ComplianceGate → Missions/Routes tabs) as the live rep surface.
	 * This flag RE-MOUNTS the governed flow behind a gate so the operator can
	 * render + review it WITHOUT disrupting the current live surface. With the
	 * flag OFF, TagesplanungPlanningContent renders exactly the pre-WU5 surface.
	 * A `?preview=governed` URL param provides an equivalent dev gate for
	 * operator preview. Flip to true (or grant via RBAC) to ship to reps.
	 */
	governed_day: false,
	// NOTE — there is deliberately NO v8 visit-report flag here. The v8 Besuchsbericht is
	// switched by ONE thing: which public.visit_questionnaire_config row is active
	// (useVisitReportV8LiveGate). The former `visit_report_v8_live` kill-switch was removed
	// (operator, 2026-10-05): a client flag in front of the config row is a second switch
	// that can only disagree with the first. flags.test.ts refuses its return.
} as const;

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;

export type FeatureFlagsMap = Record<FeatureFlagName, boolean>;

